import { useTranslation } from 'react-i18next';

import { RadarChart } from './charts';
import { ItemRow } from './ResultRow';
import {
  FatigueBadIcon,
  FatigueBestIcon,
  FatigueHoarseIcon,
  FatigueNormalIcon,
  Pill,
  SectionHeadCard,
} from '../../../../components';

/**
 * 목소리 피로도 (시안 `921:5549`) — **아직 아무 축도 못 잰다.**
 *
 * 시안은 축 넷(최상·보통·살짝 잠김·난조 — 화면 문구는 '많이 잠김', #60)의 레이더와 항목별 등급 배지를 그리는데,
 * 그 축들을 내는 산식이 엔진에 없다. 숫자를 지어내면 화면이 재지도 않은 값을 말하게
 * 되므로 레이더는 격자와 축 이름만, 네 줄은 전부 `측정 준비 중` 배지로 둔다 — **탭 자체는
 * 선다**: 이런 축이 있다는 사실이 다음 회차를 부르는 이유고, 탭을 지우면 그 약속이
 * 화면에서 사라진다.
 *
 * 축 이름·아이콘은 시안의 것을 그대로 쓴다. 값이 생기는 날 `value`만 채우면 레이더가 선다.
 */

const AXES = [
  { id: 'best', icon: FatigueBestIcon },
  { id: 'normal', icon: FatigueNormalIcon },
  { id: 'hoarse', icon: FatigueHoarseIcon },
  { id: 'bad', icon: FatigueBadIcon },
] as const;

export const FatigueSection = () => {
  const { t } = useTranslation();
  const axes = AXES.map(({ id }) => ({
    id,
    label: t(`web.result.fatigue.axis.${id}.label`),
    value: null,
  }));

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-8 py-4">
        {/* 범례를 안 그린다 — 이 레이더는 "나의 결과"도 "평균"도 그리지 않는다(축이
            전부 null). 그려 둔 범례는 화면에 없는 두 선을 약속하는 문장이다. */}
        <RadarChart axes={axes} label={t('web.result.fatigue.radarLabel')} />
      </div>

      <div className="flex flex-col gap-8 py-4">
        <SectionHeadCard
          size="md"
          className="mx-[18px]"
          title={t('web.result.tabs.details')}
        />
        <div className="flex flex-col gap-2">
          {AXES.map(({ id, icon: Icon }) => (
            <ItemRow
              key={id}
              icon={<Icon className="h-5 w-[22px]" aria-hidden="true" />}
              title={t(`web.result.fatigue.axis.${id}.label`)}
              desc={t(`web.result.fatigue.axis.${id}.note`)}
              right={<Pill tone="gray">{t('web.result.pending')}</Pill>}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
